export default __webpack_public_path__ + "static/media/PekedImg.04dce6e7.jpg";